<template>
  <el-dropdown
    :class="classes"
    v-bind="{ ...$attrs }"
    @command="handleItemClick"
    @visible-change="handleVisible"
  >
    <span
      class="el-dropdown-link"
      :class="{ 'has-icon': icon || $scopedSlots['icon'] }"
      :style="[styleObject]"
      :data-item="item.value"
    >
      <em v-if="icon || $scopedSlots['icon']">
        <slot name="icon">
          <font-awesome-icon
            v-if="icon"
            :icon="icon"
            size="1x"
          ></font-awesome-icon>
        </slot>
      </em>
      {{ label }}
      <i class="el-icon-caret-bottom el-icon--right"></i>
    </span>
    <el-dropdown-menu
      ref="dropdown"
      slot="dropdown"
      class="tg-dropdown--menu"
      :class="menuClass"
      :data-key="ekey"
    >
      <template v-for="(item, i) in compiledItems">
        <el-dropdown-item
          :command="item"
          :key="i"
          v-if="item.show != false"
          :disabled="item.disabled == true"
          :data-item="item.value"
          :class="item.class"
          >{{ item.label }}</el-dropdown-item
        >
      </template>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
export default {
  name: "TgDropdown",
  data() {
    return {
      compiledItems: [],
      item: null,
      defLabel: "請選擇",
      visible: false,
    };
  },
  props: {
    menuClass: [Object, String, Array],
    items: Array,
    icon: [String, Array],
    value: {
      type: [Object, String, Number],
      default: () => ({}),
    },
    select: [Object, String, Number],
    autoWidth: {
      type: Boolean,
      default() {
        return true;
      },
    },
    styleObject: [Object],
    width: [Number, String],
    ekey: String,
  },
  computed: {
    classes() {
      return ["tg-dropdown", { visible: this.visible }];
    },
    label() {
      return this.item
        ? this.item.label
        : this.$t("component.dropdown.default");
    },
  },
  created() {
    this.compiledItems = this.parseItems(this.items);
    if (this.value) {
      this.value2Item(this.value);
    } else if (this.select) {
      this.selectItem(this.select);
    }
  },
  mounted() {
    // this.resizeWidth();
  },
  methods: {
    resizeWidth() {
      if (this.autoWidth && this.$el.clientWidth) {
        this.$refs.dropdown.$el.style.width = this.$el.clientWidth + "px";
      } else if (this.width) {
        this.$refs.dropdown.$el.style.width = parseInt(this.width) + "px";
      }
    },
    parseItems(items) {
      let tmp = JSON.parse(JSON.stringify(items));

      tmp = tmp.map((x) => {
        let isObj = typeof x === "object";

        x = isObj
          ? x
          : {
              label: x,
              value: x,
            };

        if (x.active) {
          this.item = x;
        }
        return x;
      });

      let active = tmp.find((x) => !!x.active);
      this.item = active ? active : tmp[0];

      return tmp;
    },
    parseIcon(item) {
      let icon = "tg-icon-radio";

      if (this.item.value === item.value) {
        icon += " active";
      }
      return icon;
    },
    handleItemClick(item) {
      this.item = item;
      this.$emit("on-change", item);
    },
    handleVisible(visible) {
      this.visible = visible;
    },
    value2Item(val) {
      if (typeof val !== "object") {
        val = {
          value: val,
          label: val,
        };
      }
      this.item = val;
    },
    selectItem(val) {
      let item = this.compiledItems.find((x) => x.value == val);
      this.item = item;
      this.$emit("on-change", item);
    },
  },
  watch: {
    items(val) {
      this.compiledItems = this.parseItems(val);
      // this.resizeWidth();
    },
    value(val) {
      this.value2Item(val);
    },
  },
};
</script>
